import { useTranslation } from "react-i18next";
import { User } from "../../../models/User";
import { ConfirmationModal } from "../../ConfirmationModal";
import { TrashIcon, XMarkIcon } from "@heroicons/react/24/outline";

interface Props {
    info: {
        show: boolean;
        agent?: User;
    };
    onClose: () => void;
    deleteAgent: (agent: User) => void
}

export const RemoveBackupAgentModal: React.FC<Props> = ({
    info,
    onClose,
    deleteAgent
}) => {

    const { t } = useTranslation();

    const onDeleteAgent = () => {
        deleteAgent(info.agent!)
        onClose();
    };

    return(
        <ConfirmationModal 
            label={t("REMOVE_BACKUP_AGENT")}
            isDeleteConfirm={true}
            isOpen={info.show}
            onClose={onClose}
            cancelButton={{ label: t("CLOSE"), icon: <XMarkIcon />, onClick: onClose, }}
            saveButton={{ label: t("REMOVE"), icon: <TrashIcon />, onClick: onDeleteAgent }}
        >
            <div className='w-full flex flex-wrap items-center justify-center'>
                <label className="text-lg font-semibold py-4 px-2 text-center">
                    {t('REMOVE_BACKUP_AGENT_MESSAGE')}
                </label>
            </div>
        </ConfirmationModal>
    )
}